import { render, staticRenderFns } from "./BaseSectionLayout.vue?vue&type=template&id=5a64794e&scoped=true"
import script from "./BaseSectionLayout.vue?vue&type=script&lang=js"
export * from "./BaseSectionLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseSectionLayout.vue?vue&type=style&index=0&id=5a64794e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64794e",
  null
  
)

export default component.exports